enum OrderRowColPropertyEnum {
    BLANK = "blank",
    ACTIONS = "actions",
    ITEM_NO = "itemNo",
    QTY = "qty",
    BONUS_QTY = "bonusQty",
    SHIPPED = "shipped",
    NAME = "name",
    SKU = "sku",
    SHORT_DESCRIPTION = "shortDescription",
    DESCRIPTION = "description",
    COLOR = "color",
    STYLE = "style",
    PRICE_PER_UNIT = "pricePerUnit",
    ROW_TOTAL = "rowTotal",
    LIST_PRICE = "listPrice",
    COST_PRICE = "costPrice",
    COST_PER_UOM = "costPerUom",
    WIDTH = "width",
    HEIGHT = "height",
    DEPTH = "depth",
    UNIT_OF_MEASURE = "unitOfMeasure",
    CUSTOM = "custom",
    NET_PRICE = "netPrice",
    DISCOUNT = "discount",
    LOCATION = "location",
    MAP = "map",
    ITEM_PRICE_GROUP = "itemPriceGroup",
    UOM_BASE_QTY = "uomBaseQty",
    MSRP = "msrp",
    ITEM_OPTIONS = "itemOptions",
}

export default OrderRowColPropertyEnum;
